import React from 'react';
import {Link} from "react-router-dom";
import "./TopMenu.scss";

function TopMenu() {
    const contactForm = "53b7a210-875f-442b-a34e-f21253a2c972";

    return (
        <div className="top-menu">
            <Link to={{pathname: `/`}}>Scripts</Link>
            <Link to={{pathname: `/info`}}>Info</Link>
            {contactForm ? <Link to={{pathname: `/contact`}}>Contact</Link> : null}
            <a className="subscribe" href="https://www.youtube.com/@scriptifyroblox" target="_blank" rel="noreferrer">Subscribe</a>
        </div>
    );
}

export default TopMenu;
